import React from 'react';
import { Button, Skeleton } from '@radix-ui/themes';
import { Link } from 'react-router-dom';
import { useWindowSize } from 'helpers/useWindowSize';
import Container from './Container';

const PlayerStateOfForm: React.FC<{
  state?: boolean[];
  title?: string;
  max?: number;
  showLinkToStatsPage?: boolean;
  playerId?: number;
  loading?: boolean;
}> = ({ state = [], title = 'Stato di forma', max = 10, showLinkToStatsPage = false, playerId, loading = false }) => {
  // show most recent matches first: reverse a copy then take up to `max`
  const items = (state || []).slice(0, max).reverse();
  const placeholderCount = Math.min(max, 6);
  const size = useWindowSize();
  const isDesktop = (size.width || 0) > 768;
  const iconClass = isDesktop ? 'h-12 w-12 text-sm' : 'h-6 w-6 text-xs';
  const skeletonClass = isDesktop ? 'h-12 w-12 rounded-full' : 'h-6 w-6 rounded-full';
  const legendIconClass = isDesktop ? 'h-8 w-8 text-[12px]' : 'h-4 w-4 text-[10px]';

  return (
    <Container title={title}>
      <div className='flex flex-row gap-3'>
        <div className='flex w-28 flex-none flex-col items-center justify-between gap-3 md:w-40'>
          <Skeleton loading={loading} className='h-4 w-28'>
            <div className='text-neutral-neutral-7 text-sm'>Ultimi {items.length} match</div>
          </Skeleton>
        </div>

        <div className='mt-2 flex flex-1 flex-col flex-wrap gap-2' role='list' aria-label={title}>
          <div className='flex flex-row flex-wrap gap-2'>
            {loading ? (
              // skeleton placeholders
              Array.from({ length: placeholderCount }).map((_, i) => (
                <Skeleton key={i} loading={true} className={skeletonClass} />
              ))
            ) : items.length === 0 ? (
              <div className='text-neutral-neutral-6 text-sm'>Nessun dato</div>
            ) : (
              items.map((s, i) => (
                <div
                  key={i}
                  role='listitem'
                  aria-label={s ? 'Vittoria' : 'Sconfitta'}
                  title={s ? 'W - Vittoria' : 'L - Sconfitta'}
                  className={`flex ${iconClass} items-center justify-center rounded-full font-bold shadow-xs ${
                    s ? 'bg-accent-accent-8 text-accent-accent-1' : 'bg-red-9 text-red-1'
                  }`}
                >
                  {s ? 'W' : 'L'}
                </div>
              ))
            )}
          </div>
          <div className='text-neutral-neutral-6 mt-3 flex items-center gap-3 text-xs'>
            <Skeleton loading={loading} className='h-4 w-32'>
              <div className='flex items-center gap-2'>
                <div
                  className={`flex ${legendIconClass} bg-accent-accent-8 text-accent-accent-1 items-center justify-center rounded-full font-bold`}
                >
                  W
                </div>
                <div>Vittoria</div>
              </div>
            </Skeleton>
            <Skeleton loading={loading} className='h-4 w-32'>
              <div className='flex items-center gap-2'>
                <div
                  className={`flex ${legendIconClass} bg-red-9 text-red-1 items-center justify-center rounded-full font-bold`}
                >
                  L
                </div>
                <div>Sconfitta</div>
              </div>
            </Skeleton>
          </div>
        </div>
      </div>
      {showLinkToStatsPage && (
        <div className='mt-4'>
          <Link to={`/giocatore/${playerId}/statistiche`}>
            <Button className='mt-4'>Vedi tutte le statistiche</Button>
          </Link>
        </div>
      )}
    </Container>
  );
};

export default PlayerStateOfForm;
